import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Input, InputPropTypes } from './input';

// import styles from './textarea.module.scss';

export const Textarea = forwardRef(
	({ type, wrapper, rows = 15, cols = 5, ...props }, ref) => (
		<Input {...props} ref={ref} rows={rows} cols={cols} type={null} wrapper="textarea" />
	)
);

Textarea.propTypes = {
	...InputPropTypes,
	rows: PropTypes.number,
	cols: PropTypes.number,
};
